/* ============================================================
   MAVI — Theme JS: hero slider + mobile menu
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Hero slider ---------- */
  function initSlider(root) {
    var track = root.querySelector('[data-slider-track]');
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-slider-dot]');
    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');
    if (!track || slides.length < 2) return;

    var index = 0;
    var count = slides.length;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = (parseInt(root.getAttribute('data-speed'), 10) || 6) * 1000;
    var timer = null;

    function go(i) {
      index = (i + count) % count;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      // re-trigger content animation
      var content = slides[index].querySelector('.hero-slide__content');
      if (content) {
        content.style.animation = 'none';
        void content.offsetWidth;
        content.style.animation = '';
      }
    }

    function nextSlide() { go(index + 1); }
    function start() { if (autoplay) { stop(); timer = setInterval(nextSlide, speed); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (next) next.addEventListener('click', function () { nextSlide(); start(); });
    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slider-dot'), 10)); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // Touch / swipe support
    var startX = 0;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { dx < 0 ? nextSlide() : go(index - 1); }
      start();
    }, { passive: true });

    // Keyboard
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { nextSlide(); start(); }
      if (e.key === 'ArrowLeft') { go(index - 1); start(); }
    });

    go(0);
    start();
  }

  /* ---------- Mobile menu (event-delegated so it works even if the header is injected later) ---------- */
  function initMenu() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest && e.target.closest('[data-menu-toggle]');
      if (toggle) {
        var header = document.querySelector('[data-header]');
        if (!header) return;
        var open = header.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      // Close the menu when a nav link is tapped, or when tapping outside the open panel
      var header2 = document.querySelector('[data-header].is-open');
      if (!header2) return;
      if (e.target.closest('.site-header__nav a')) { header2.classList.remove('is-open'); return; }
      if (!e.target.closest('.site-header__nav') && !e.target.closest('[data-menu-toggle]')) header2.classList.remove('is-open');
    });
  }

  /* ---------- Search overlay (opens on the search icon; submits to Shopify search) ---------- */
  function initSearch() {
    var overlay = document.querySelector('[data-search]');
    if (!overlay) return;
    var input = overlay.querySelector('input[type="search"]');
    function open() { overlay.classList.add('is-open'); setTimeout(function () { if (input) input.focus(); }, 60); }
    function close() { overlay.classList.remove('is-open'); }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-search-open]');
      if (opener) { e.preventDefault(); open(); return; }
      if (e.target.closest && e.target.closest('[data-search-close]')) { close(); return; }
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Persistent sticky header: always visible, adds shadow once scrolled ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    header.classList.remove('is-hidden'); // never hide — it travels with the page
    var ticking = false;
    function update() {
      ticking = false;
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Smooth page transitions (fade out → navigate → fade in) ---------- */
  function initPageTransitions() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href) return;
      if (a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href === '' || href === '#') return;
      var url;
      try { url = new URL(href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      // In-page anchor → let the smooth scroller handle it
      if (url.pathname === window.location.pathname && url.hash) return;
      e.preventDefault();
      document.documentElement.classList.add('page-leaving');
      setTimeout(function () { window.location.href = url.href; }, 400);
    });
    // Restore visibility if the page is shown from the bfcache (back/forward)
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) document.documentElement.classList.remove('page-leaving');
    });
  }

  /* ---------- Smooth momentum scrolling (Lenis-style, dependency-free) ---------- */
  function initSmoothScroll() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(pointer: fine)').matches;
    // Only on precise-pointer, motion-OK devices. Touch keeps its native momentum.
    if (reduce || !fine) return;

    document.documentElement.classList.add('has-smooth-scroll');
    document.documentElement.style.scrollBehavior = 'auto';

    var target = window.scrollY || window.pageYOffset;
    var current = target;
    var ease = 0.1;
    var running = false;

    function maxScroll() {
      return Math.max(0, (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight);
    }
    function clamp(v) { return Math.max(0, Math.min(v, maxScroll())); }

    function frame() {
      var diff = target - current;
      current += diff * ease;
      if (Math.abs(diff) < 0.4) {
        current = target;
        window.scrollTo(0, Math.round(current));
        running = false;
        return;
      }
      window.scrollTo(0, current);
      requestAnimationFrame(frame);
    }
    function run() { if (!running) { running = true; requestAnimationFrame(frame); } }

    window.addEventListener('wheel', function (e) {
      // Let pinch-zoom and open overlays/menus behave natively
      if (e.ctrlKey) return;
      if (document.querySelector('.search-overlay.is-open') || document.querySelector('.site-header.is-open')) return;
      var d = e.deltaY;
      if (e.deltaMode === 1) d *= 16;          // lines → px
      else if (e.deltaMode === 2) d *= window.innerHeight; // pages → px
      if (!d) return;
      e.preventDefault();
      target = clamp(target + d);
      run();
    }, { passive: false });

    // Re-sync when scrolled by other means (scrollbar, keyboard, anchors)
    window.addEventListener('scroll', function () {
      if (!running) { target = window.scrollY; current = window.scrollY; }
    }, { passive: true });
    window.addEventListener('resize', function () { target = clamp(target); });

    // Smoothly glide in-page anchor links (incl. same-page "index.html#section" nav links)
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href) return;
      var hash = null;
      if (href.charAt(0) === '#') {
        hash = href;
      } else {
        var url; try { url = new URL(href, window.location.href); } catch (err) { return; }
        if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.hash) hash = url.hash;
      }
      if (!hash || hash.length < 2) return;
      var el = document.querySelector(hash);
      if (!el) return;
      e.preventDefault();
      target = clamp(el.getBoundingClientRect().top + window.scrollY - 80);
      run();
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    document.querySelectorAll('.accordion__item').forEach(function (it, i) {
      var head = it.querySelector('.accordion__head');
      var body = it.querySelector('.accordion__body');
      if (!head || !body) return;
      if (i === 0) { it.classList.add('is-open'); body.style.maxHeight = body.scrollHeight + 'px'; }
      head.addEventListener('click', function () {
        var open = it.classList.toggle('is-open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : 0;
      });
    });
  }

  /* ---------- Product: size pills + qty + variant matching + live price ---------- */
  function initProductForm() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    // Quantity stepper
    var qtyEl = form.querySelector('[data-qty]');
    var minus = form.querySelector('[data-qminus]');
    var plus = form.querySelector('[data-qplus]');
    if (minus && plus && qtyEl) {
      minus.addEventListener('click', function () { qtyEl.value = Math.max(1, (parseInt(qtyEl.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qtyEl.value = (parseInt(qtyEl.value, 10) || 1) + 1; });
    }

    // Variant matching
    var variants = [];
    var blob = form.querySelector('[data-variants]');
    try { variants = JSON.parse(blob.textContent); } catch (e) { variants = []; }
    var idField = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var saveEl = document.querySelector('[data-save]');
    var addBtn = form.querySelector('[name="add"]');
    if (!variants.length || !idField) return;

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-opt]').forEach(function (el) {
        if (el.tagName === 'SELECT') { opts[+el.getAttribute('data-opt')] = el.value; }
        else if (el.type === 'radio' && el.checked) { opts[+el.getAttribute('data-opt')] = el.value; }
      });
      return opts;
    }
    function update() {
      var chosen = selectedOptions();
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return chosen[i] === undefined || o === chosen[i]; });
      })[0];
      if (!match) return;
      idField.value = match.id;
      if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
      // A variant on offer carries a higher compare-at price; hide both bits when it isn't.
      var onOffer = match.compare_at_price && match.compare_at_price > match.price;
      if (compareEl) {
        compareEl.textContent = onOffer ? match.compare_at_formatted : '';
        compareEl.hidden = !onOffer;
      }
      if (saveEl) saveEl.hidden = !onOffer;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
    }
    form.querySelectorAll('[data-opt]').forEach(function (el) {
      el.addEventListener('change', function () {
        // toggle size-pill active state
        if (el.type === 'radio') {
          var pills = el.closest('.size-pills');
          if (pills) pills.querySelectorAll('.size-pill').forEach(function (p) {
            p.classList.toggle('is-active', p.contains(el) || (p.querySelector('input') && p.querySelector('input').checked));
          });
        }
        update();
      });
    });
    // clicking a size-pill label checks its radio
    form.querySelectorAll('.size-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var r = pill.querySelector('input[type="radio"]');
        if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
    update();
  }

  /* ---------- Product image gallery (thumbnail swap) ---------- */
  function initGallery() {
    var main = document.querySelector('[data-main-img]');
    var thumbs = document.querySelectorAll('[data-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-full') || t.src;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---------- Light / Dark theme toggle ---------- */
  var SUN = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="4.2"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>';
  var MOON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>';
  function currentTheme() { return document.documentElement.getAttribute('data-theme') || 'light'; }
  function initThemeToggle() {
    var btns = document.querySelectorAll('[data-theme-toggle]');
    if (!btns.length) return;
    function paint() {
      var t = currentTheme();
      btns.forEach(function (b) {
        b.innerHTML = t === 'light' ? MOON : SUN;
        b.setAttribute('aria-label', t === 'light' ? 'Switch to dark mode' : 'Switch to light mode');
      });
    }
    paint();
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var t = currentTheme() === 'light' ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', t);
        try { localStorage.setItem('mavi-theme', t); } catch (e) {}
        paint();
      });
    });
  }

  /* ---------- Reviews: sort filter + shopper-written reviews ----------
     Reviews written here live in the visitor's own browser (localStorage). Shopify has no
     native review storage — connect a reviews app to persist them across visitors. */
  function initReviews(root) {
    var grid = root.querySelector('[data-reviews-grid]');
    if (!grid) return;
    var key = 'mavi_reviews';

    function stored() {
      try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
    }
    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s == null ? '' : String(s);
      return d.innerHTML;
    }
    function starRow(n) {
      var s = '';
      for (var i = 1; i <= 5; i++) s += i <= n ? '★' : '☆';
      return s;
    }
    function cardHTML(r, order) {
      return '<div class="review-card" data-review data-rating="' + r.rating + '" data-order="' + order + '">' +
        '<div class="stars">' + starRow(r.rating) + '</div>' +
        '<div class="review-card__head">' +
          '<span class="review-card__avatar">' + esc((r.author || 'A').charAt(0).toUpperCase()) + '</span>' +
          '<span class="review-card__name">' + esc(r.author) + '</span>' +
        '</div>' +
        '<h3 class="review-card__title">' + esc(r.title) + '</h3>' +
        '<p class="review-card__body">' + esc(r.body) + '</p>' +
        '<p class="review-card__date">' + esc(r.date || 'Just now') + '</p>' +
      '</div>';
    }

    // Shopper reviews are newest, so they sit above the theme-editor ones.
    // Re-number every card so "Most Recent" has a single ordering to sort on.
    function mount() {
      var mine = stored();
      for (var i = mine.length - 1; i >= 0; i--) grid.insertAdjacentHTML('afterbegin', cardHTML(mine[i], 0));
      [].forEach.call(grid.querySelectorAll('[data-review]'), function (c, i) { c.setAttribute('data-order', i); });
      var empty = root.querySelector('[data-reviews-empty]');
      if (empty && grid.querySelector('[data-review]')) empty.remove();
      refreshSummary();
    }

    function refreshSummary() {
      var cards = [].slice.call(grid.querySelectorAll('[data-review]'));
      var total = cards.length;
      if (!total) return;
      var counts = [0, 0, 0, 0, 0], sum = 0;
      cards.forEach(function (c) {
        var r = Math.min(5, Math.max(1, parseInt(c.getAttribute('data-rating'), 10) || 0));
        sum += r; counts[5 - r]++;
      });
      var avg = sum / total;
      var avgStars = root.querySelector('.reviews__avg .stars');
      var avgScore = root.querySelector('.reviews__avg-score');
      var avgCount = root.querySelector('.reviews__avg-count');
      if (avgStars) avgStars.textContent = starRow(Math.round(avg));
      if (avgScore) avgScore.textContent = avg.toFixed(2) + ' out of 5';
      if (avgCount) avgCount.textContent = 'Based on ' + total + ' review' + (total === 1 ? '' : 's');
      var rows = root.querySelectorAll('.reviews__bar-row');
      [].forEach.call(rows, function (row, i) {
        var fill = row.querySelector('.reviews__bar-fill');
        var num = row.querySelector('.reviews__bar-count');
        var pct = Math.round((counts[i] / total) * 100);
        if (fill) fill.style.width = pct + '%';
        if (num) num.textContent = counts[i];
      });
    }

    function sortBy(mode) {
      var cards = [].slice.call(grid.querySelectorAll('[data-review]'));
      cards.sort(function (a, b) {
        var ra = +a.getAttribute('data-rating'), rb = +b.getAttribute('data-rating');
        var oa = +a.getAttribute('data-order'), ob = +b.getAttribute('data-order');
        if (mode === 'high' && rb !== ra) return rb - ra;
        if (mode === 'low' && ra !== rb) return ra - rb;
        return oa - ob;   // tie-break (and 'recent') by original order
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    }

    mount();

    var select = root.querySelector('[data-review-sort]');
    if (select) select.addEventListener('change', function () { sortBy(this.value); });

    var form = root.querySelector('[data-review-form]');
    var openBtn = root.querySelector('[data-write-review]');
    if (openBtn && form) {
      openBtn.addEventListener('click', function () {
        form.classList.toggle('is-open');
        if (form.classList.contains('is-open')) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    if (!form) return;

    var picked = 5;
    var picker = form.querySelector('[data-star-picker]');
    function paint() {
      [].forEach.call(picker.querySelectorAll('span'), function (s) {
        s.classList.toggle('on', +s.getAttribute('data-star') <= picked);
      });
    }
    paint();
    [].forEach.call(picker.querySelectorAll('span'), function (s) {
      s.addEventListener('click', function () { picked = +s.getAttribute('data-star'); paint(); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var review = {
        author: form.querySelector('[data-rv-name]').value || 'Anonymous',
        rating: picked,
        title: form.querySelector('[data-rv-title]').value || 'Review',
        body: form.querySelector('[data-rv-body]').value || '',
        date: 'Just now'
      };
      var all = stored();
      all.unshift(review);
      try { localStorage.setItem(key, JSON.stringify(all)); } catch (err) {}

      grid.insertAdjacentHTML('afterbegin', cardHTML(review, 0));
      [].forEach.call(grid.querySelectorAll('[data-review]'), function (c, i) { c.setAttribute('data-order', i); });
      var empty = root.querySelector('[data-reviews-empty]');
      if (empty) empty.remove();
      refreshSummary();
      if (select) { select.value = 'recent'; sortBy('recent'); }
      form.reset();
      picked = 5; paint();
      form.classList.remove('is-open');
      grid.querySelector('[data-review]').scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Cart quantity steppers ---------- */
  function initCart() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    // +/- adjust the line quantity then submit; posting to /cart with updates[]
    // updates the line and redirects back to the cart (no button name = update, not checkout).
    form.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-cart-minus]');
      var plus = e.target.closest('[data-cart-plus]');
      if (!minus && !plus) return;
      var row = e.target.closest('.cart-item');
      var input = row && row.querySelector('[data-cart-qty]');
      if (!input) return;
      e.preventDefault();
      var val = parseInt(input.value, 10) || 0;
      input.value = plus ? val + 1 : Math.max(0, val - 1);
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    });

    // Typing a new quantity and blurring / pressing Enter also updates.
    form.addEventListener('change', function (e) {
      if (!e.target.closest('[data-cart-qty]')) return;
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.reviews').forEach(initReviews);
    document.querySelectorAll('[data-hero-slider]').forEach(initSlider);
    initPageTransitions();
    initSmoothScroll();
    initMenu();
    initSearch();
    initHeaderScroll();
    initReveal();
    initAccordions();
    initProductForm();
    initGallery();
    initThemeToggle();
    initCart();
  });

  // Support Shopify theme editor section reloads
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var slider = e.target.querySelector('[data-hero-slider]');
      if (slider) initSlider(slider);
    });
  }
})();
